import { Badge, Icon } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { Info } from '@src/components/icons/info';

import { ServiceBannerInfoSheet } from '../ServiceBannerInfoSheet';

import styles from './ServiceOneBadge.module.scss';

export function ServiceOneBadge({ className, text }: { className: string; text: string }) {
  const [viisble, setVisible] = useBoolean();
  return (
    <>
      <Badge
        color="blue"
        variant="primary"
        text={
          <>
            <span>{text}</span>
            <Icon
              icon={<Info />}
              className={styles.icon}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setVisible.on();
              }}
            />
          </>
        }
        className={className}
      />
      <ServiceBannerInfoSheet
        visible={viisble}
        onClose={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setVisible.off();
        }}
      />
    </>
  );
}
